var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _vm.showSearch
        ? _c(
            "span",
            {
              staticClass: "selectSearchable__wrapper input__wrapper",
              attrs: {
                role: "search",
                "aria-labelledby": _vm.searchInputLabelledBy,
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "text-color--gray-blue input__icon",
                  attrs: { height: "16", width: "16", "aria-hidden": "true" },
                },
                [_c("use", { attrs: { href: "#iconMagnifyingGlassRegular" } })]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchInput,
                    expression: "searchInput",
                  },
                ],
                staticClass: "tagged-input__realinput",
                attrs: {
                  id: _vm.searchId,
                  type: "search",
                  name: _vm.searchName,
                  disabled: _vm.disabled,
                  placeholder: _vm.searchPlaceholder,
                  "aria-labelledby": _vm.searchInputLabelledBy,
                  autocomplete: "off",
                },
                domProps: { value: _vm.searchInput },
                on: {
                  keydown: [
                    _vm.scrollToResult,
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                      )
                        return null
                      $event.preventDefault()
                      return _vm.tabToResult.apply(null, arguments)
                    },
                  ],
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.searchInput = $event.target.value
                  },
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "scrollbox",
          staticClass: "selectSearchable__scrollbox checkboxGroup scrollBox",
          style: { height: `${_vm.optionsHeight}px` },
          attrs: {
            id: _vm.id,
            disabled: _vm.disabled,
            role: "listbox",
            tabindex: "0",
          },
        },
        _vm._l(_vm.optionsData, function (option) {
          return _c(
            "label",
            {
              key: option.value,
              staticClass:
                "sidebarFilter__wrapper sidebarFilter__wrapper--checkBox sidebarFilter__checkBoxLabel",
              attrs: {
                id: `${_vm.optionIdPrefix}label_${option.value}`,
                for: _vm.optionIdPrefix + option.value,
                role: "option",
                "aria-selected": option[_vm.optionCheckedProp],
                tabindex: option[_vm.optionCheckedProp] ? 0 : -1,
              },
            },
            [
              _c("span", { staticClass: "sidebarFilter__searchableCheckBox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: option[_vm.optionCheckedProp],
                      expression: "option[optionCheckedProp]",
                    },
                  ],
                  staticClass: "customCheckboxInput",
                  attrs: {
                    id: _vm.optionIdPrefix + option.value,
                    type: "checkbox",
                    name: _vm.optionIdPrefix + option.value,
                    disabled: _vm.disabled,
                  },
                  domProps: {
                    value: option.value,
                    checked: Array.isArray(option[_vm.optionCheckedProp])
                      ? _vm._i(option[_vm.optionCheckedProp], option.value) > -1
                      : option[_vm.optionCheckedProp],
                  },
                  on: {
                    change: function ($event) {
                      var $$a = option[_vm.optionCheckedProp],
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = option.value,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              option,
                              _vm.optionCheckedProp,
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              option,
                              _vm.optionCheckedProp,
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(option, _vm.optionCheckedProp, $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "customCheckbox" }),
                _vm._v(
                  "\n                    " +
                    _vm._s(option.name) +
                    "\n                "
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _vm.showTags
      ? _c(
          "div",
          _vm._l(_vm.selectedOptions, function (selectedOption) {
            return _c(
              "div",
              {
                key: selectedOption.value,
                staticClass: "filterTag",
                attrs: { tabindex: "0", role: "button" },
                on: {
                  click: function ($event) {
                    return _vm.removeSelectedOption(selectedOption)
                  },
                },
              },
              [
                _c("span", {
                  staticClass: "filterTag__text",
                  domProps: { textContent: _vm._s(selectedOption.name) },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "filterTag__icon" }, [_vm._v("×")]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }